import { Mobile } from './Mobile';

export type { TypeMobileProps } from './types';
export default Mobile;
